<template>
  <BaseModal
    :id="id"
    :modalClass="`modal-lg`"
    :showCloseButton="false"
    :headerText="headerText"
    @onClose="handleClose"
  >
    <template #body>
      <div class="container-body">
        <slot
          :topBodyProps="topBodyProps"
          name="body-top" />
        <CustomMasterDataForm
          v-model="input"
          :disabled="isSubmitting"
          :showCheckboxDefault="showCheckboxDefault"
          :master-data-title="masterDataTitle"
        />
      </div>
    </template>
    <template #footer>
      <button
        :disabled="isSubmitting"
        type="button"
        class="btn btn-light"
        @click="handleClose"
      >{{ $t('button.cancel') }}</button>
      <button
        :disabled="isSubmitting"
        type="button"
        class="btn btn-web"
        @click="handleSubmit"
      >{{ $t('button.apply') }}</button>
    </template>
  </BaseModal>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  props: {
    id: {
      type: String,
    },
    headerText: {
      type: String,
    },
    isSubmitting: {
      type: Boolean,
    },
    list: {
      type: Array,
    },
    showCheckboxDefault: {
      type: Boolean,
      default: true,
    },
    topBodyProps: {
      type: Object,
    },
    masterDataTitle: {
      type: String,
    },
  },

  data() {
    return {
      input: [],
    }
  },

  watch: {
    list: {
      handler: function () {
        this.input = cloneDeep(this.list)
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    handleClose () {
      this.$emit('onClose')
    },
    handleSubmit() {
      const data = this.input.filter((item) => item.name.trim().length > 0)
      this.$emit('onSubmit', data, {
        topBodyProps: this.topBodyProps,
      })
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/base/BaseModalCustomMasterData.vue